module.exports = __webpack_public_path__ + "media/MRI21-ad.fc464a0a.mp3";